import { useState, useEffect } from 'react';
import { getTracks, getTracksForSubmit, getTracksForAsk } from '../services/tracksService';

/**
 * Hook to fetch and manage track data
 */
export function useTracks() {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTracks();
  }, []);

  const fetchTracks = async () => {
    try {
      setLoading(true);
      setError(null);
      const tracksData = await getTracks();
      setTracks(tracksData);
    } catch (err) {
      console.error('Error in useTracks:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refreshTracks = () => {
    fetchTracks();
  };

  return {
    tracks,
    loading,
    error,
    refreshTracks
  };
}

/**
 * Hook to get tracks formatted for submit page dropdown
 */
export function useTracksForSubmit() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      setLoading(true);
      setError(null);
      const submitOptions = await getTracksForSubmit();
      setOptions(submitOptions);
    } catch (err) {
      console.error('Error in useTracksForSubmit:', err);
      setError(err.message);
      // Fallback options - use track names as values
      setOptions([
        { value: 'Smart Charging', label: 'Smart Charging' },
        { value: 'Tailings Treatment', label: 'Tailings Treatment' },
        { value: 'Bitumen Viscosity', label: 'Bitumen Viscosity' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  return {
    options,
    loading,
    error,
    refreshOptions: fetchOptions
  };
}

/**
 * Hook to get tracks formatted for ask page dropdown (includes general)
 */
export function useTracksForAsk() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      setLoading(true);
      setError(null);
      const askOptions = await getTracksForAsk();
      setOptions(askOptions);
    } catch (err) {
      console.error('Error in useTracksForAsk:', err);
      setError(err.message);
      // Fallback options
      setOptions([
        { value: 'general', label: 'General' },
        { value: 'track1', label: 'Smart Charging' },
        { value: 'track2', label: 'Tailings Treatment' },
        { value: 'track3', label: 'Bitumen Viscosity' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  return {
    options,
    loading,
    error,
    refreshOptions: fetchOptions
  };
}
